/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventRuleAdminDTO } from '../models/EventRuleAdminDTO';
import type { EventRuleCreateRequest } from '../models/EventRuleCreateRequest';
import type { EventRulesListResponse } from '../models/EventRulesListResponse';
import type { EventRuleUpdateRequest } from '../models/EventRuleUpdateRequest';
import type { StreakTargetsResponse } from '../models/StreakTargetsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminEventRulesService {
    /**
     * List Streak Targets
     * Selectable Streak Alert targets (e.g. "Missed call") — named
     * ``(trigger, condition)`` presets the UI offers so an admin never
     * hand-builds the outcome matcher.
     * @returns StreakTargetsResponse Successful Response
     * @throws ApiError
     */
    public static listStreakTargetsApiAdminEventRulesStreakTargetsGet(): CancelablePromise<StreakTargetsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/event-rules/streak-targets',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Event Rules
     * All rules visible to the caller's organization: global rules plus
     * rules scoped to campaigns the org owns.
     * @returns EventRulesListResponse Successful Response
     * @throws ApiError
     */
    public static listEventRulesApiAdminEventRulesGet(): CancelablePromise<EventRulesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/event-rules',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Event Rule
     * @param requestBody
     * @returns EventRuleAdminDTO Successful Response
     * @throws ApiError
     */
    public static createEventRuleApiAdminEventRulesPost(
        requestBody: EventRuleCreateRequest,
    ): CancelablePromise<EventRuleAdminDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event-rules',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Event Rule
     * @param ruleId
     * @param requestBody
     * @returns EventRuleAdminDTO Successful Response
     * @throws ApiError
     */
    public static updateEventRuleApiAdminEventRulesRuleIdPatch(
        ruleId: string,
        requestBody: EventRuleUpdateRequest,
    ): CancelablePromise<EventRuleAdminDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/event-rules/{rule_id}',
            path: {
                'rule_id': ruleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Event Rule
     * @param ruleId
     * @returns void
     * @throws ApiError
     */
    public static deleteEventRuleApiAdminEventRulesRuleIdDelete(
        ruleId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/event-rules/{rule_id}',
            path: {
                'rule_id': ruleId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Streak Targets
     * Selectable Streak Alert targets (e.g. "Missed call") — named
     * ``(trigger, condition)`` presets the UI offers so an admin never
     * hand-builds the outcome matcher.
     * @returns StreakTargetsResponse Successful Response
     * @throws ApiError
     */
    public static listStreakTargetsAdminEventRulesStreakTargetsGet(): CancelablePromise<StreakTargetsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/event-rules/streak-targets',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Event Rules
     * All rules visible to the caller's organization: global rules plus
     * rules scoped to campaigns the org owns.
     * @returns EventRulesListResponse Successful Response
     * @throws ApiError
     */
    public static listEventRulesAdminEventRulesGet(): CancelablePromise<EventRulesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/event-rules',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Event Rule
     * @param requestBody
     * @returns EventRuleAdminDTO Successful Response
     * @throws ApiError
     */
    public static createEventRuleAdminEventRulesPost(
        requestBody: EventRuleCreateRequest,
    ): CancelablePromise<EventRuleAdminDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/event-rules',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Event Rule
     * @param ruleId
     * @param requestBody
     * @returns EventRuleAdminDTO Successful Response
     * @throws ApiError
     */
    public static updateEventRuleAdminEventRulesRuleIdPatch(
        ruleId: string,
        requestBody: EventRuleUpdateRequest,
    ): CancelablePromise<EventRuleAdminDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/event-rules/{rule_id}',
            path: {
                'rule_id': ruleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Event Rule
     * @param ruleId
     * @returns void
     * @throws ApiError
     */
    public static deleteEventRuleAdminEventRulesRuleIdDelete(
        ruleId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/event-rules/{rule_id}',
            path: {
                'rule_id': ruleId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
